export const DEFAULT_B2B_RANGE_ID = 'ffa6291e-0627-446e-8093-e6cf92a0c28e';
export const DEFAULT_B2C_RANGE_ID = 'c3ad6b6c-9b4c-435c-bbc8-428ede606859';

export const DEFAULT_RANGE_IDS = [DEFAULT_B2B_RANGE_ID, DEFAULT_B2C_RANGE_ID];
